import {React ,useState} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import './SignupForm.css'




const SignUpForm = () => {
  // const initialValues = {
  //   name: '',
  //   email: '',
  //   password: '',
  // };

  // const onSubmit = (values) => {
  //   // Handle form submission (e.g., send data to server)
  //   console.log(values);
  // }

  const [formVisible, setFormVisible] = useState(true);

  const closeHandler = () => {
    setFormVisible(false);
  };

  return (
    <>
      {formVisible &&
      <div className="overlay">
        <div className="sign-up-form m-auto">
          <div className="heading-form">
            <h2 className='sign-head mt-2'>Sign Up</h2>
            <div className="close-btn">
              <button className="close-button" onClick={closeHandler}>
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
          </div>
          <div className="form mt-4">
            <input className='input-fields m-3' type="text" placeholder='Full Name' />
            <input className='input-fields m-3' type="text" placeholder='Email' />
            <input className='m-1 checkbox' type="checkbox" />
            <p className='terms-condition'>I agree to Zomato's <span>Terms of Service Privacy Policy</span> and <span>Content Policies</span></p>
            <div className="btn-sign-up-wrapper mt-4 d-flex flex-column align-center justify-content-center">
              <button className='btn-sign_up mx-auto' type='button'>Create account</button>
              <p className='text-center mt-1 mb-0'>or</p>
              <button className='google-acc mx-auto mt-2' type="button">Continue with Google</button>
            </div>
            <p className='end-sign mt-2'>Already have an account ? <a href='/'>Log in</a></p>
          </div>
        </div>
        </div>
      }
    </>
  );
}
export default SignUpForm;



